export class UserNotificationSettingsCtrl {}
